import { ErrorHandler, Injectable, Injector } from '@angular/core';

// custom service for uncaught exceptions (Carlos)
// documentation for custom error handler: https://angular.io/api/core/ErrorHandler (Carlos)
@Injectable()
export class CustomErrorHandlerService extends ErrorHandler {
  constructor(private injector: Injector) {
    super();
  }

  handleError(error) {
    const rollbar = this.injector.get('Rollbar');

    rollbar.error(error);

    // call default angular error handler (Carlos)
    super.handleError(error);
  }
}
